import React, {Suspense} from 'react'
import {
	Navigate,
	Outlet,
	RouterProvider,
	createBrowserRouter,
	useLocation,
} from 'react-router-dom'
import Layout from '~/components/layout/Layout'
import {useAuthenticated} from '~/hooks/useAuthenticated'
import CoffeeView from '../components/CoffeeView'
import FullPageLoading from '../components/FullPageLoading'
import CustomErrorBoundary from './CustomErrorBoundary'

const LoginPage = React.lazy(() => import('~/pages/LoginPage'))
const VersionListPage = React.lazy(() => import('~/pages/VersionListPage'))
// const VersionListPage = React.lazy(
// 	() => import('~/components/versionView/VersionList'),
// )
// const VersionViewPage = React.lazy(
// 	() => import('~/components/versionView/VersionView'),
// )
// const InfoViewPage = React.lazy(
// 	() => import('~/components/versionView/InfoView'),
// )
// const FormulasViewPage = React.lazy(
// 	() => import('~/components/versionView/Formula/FormulasView'),
// )
// const PricingSheetViewPage = React.lazy(
// 	() => import('~/components/versionView/PricingSheetView'),
// )
const InfoPage = React.lazy(() => import('~/pages/InfoPage'))
const ItemsPage = React.lazy(() => import('~/pages/ItemsPage'))
const AutomationPage = React.lazy(() => import('~/pages/AutomationPage'))

export const WithLoader: React.FC<{children: React.ReactNode}> = ({
	children,
}) => {
	return <Suspense fallback={<FullPageLoading />}>{children}</Suspense>
}

export const RequireAuth: React.FC<{children: React.ReactNode}> = ({
	children,
}) => {
	const {isUserLoggedIn} = useAuthenticated()
	const location = useLocation()

	if (!isUserLoggedIn) {
		return <Navigate to="/login" state={{from: location}} />
	}

	return <>{children}</>
}

const router = createBrowserRouter([
	{
		path: '/',
		element: (
			<RequireAuth>
				<Layout>
					<CoffeeView />
				</Layout>
			</RequireAuth>
		),
		errorElement: <CustomErrorBoundary />,
	},
	{
		path: 'pricing',
		element: (
			<RequireAuth>
				<Layout>
					<Outlet />
				</Layout>
			</RequireAuth>
		),
		children: [
			{
				path: '',
				element: (
					<WithLoader>
						<VersionListPage />
					</WithLoader>
				),
				errorElement: <CustomErrorBoundary />,
			},
			{
				path: ':versionId/info',
				element: (
					<WithLoader>
						<InfoPage />
					</WithLoader>
				),
				// children: [
				// {
				// 	path: 'info',
				// 	element: (
				// 		<WithLoader>
				// 			Info
				// 			{/* <InfoViewPage /> */}
				// 		</WithLoader>
				// 	),
				// 	errorElement: <CustomErrorBoundary />,
				// },
				// {
				// 	path: 'formulas',
				// 	element: (
				// 		<WithLoader>
				// 			<FormulasViewPage />
				// 		</WithLoader>
				// 	),
				// 	errorElement: <CustomErrorBoundary />,
				// },
				// {
				// 	path: 'pricing-sheets',
				// 	element: (
				// 		<WithLoader>
				// 			<PricingSheetViewPage />
				// 		</WithLoader>
				// 	),
				// 	errorElement: <CustomErrorBoundary />,
				// },
				// {
				// 	path: 'revenue-estimation',
				// 	element: <CoffeeView />,
				// 	errorElement: <CustomErrorBoundary />,
				// },
				// ],
				errorElement: <CustomErrorBoundary />,
			},
			{
				path: ':versionId/items',
				element: (
					<WithLoader>
						<ItemsPage />
					</WithLoader>
				),
				errorElement: <CustomErrorBoundary />,
			},
			{
				path: ':versionId/automation',
				element: (
					<WithLoader>
						<AutomationPage />
					</WithLoader>
				),
				errorElement: <CustomErrorBoundary />,
			},
		],
		errorElement: <CustomErrorBoundary />,
	},
	{
		path: 'login',
		element: (
			<WithLoader>
				<LoginPage />
			</WithLoader>
		),
		errorElement: <CustomErrorBoundary />,
	},
	{
		path: '*',
		element: <CoffeeView />,
		errorElement: <CustomErrorBoundary />,
	},
])

const RouteWrapper: React.FC = () => {
	return <RouterProvider router={router} />
}

export default RouteWrapper
